import React from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import _ from 'underscore';

class AutosuggestSearch extends React.Component {
  state = {
    suggestions: [],
    value: ''
  }

  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  getSuggestions(value) {
    const escapedValue = this.escapeRegexCharacters(value.trim());
    const visibleLength = this.props.visibleValues.length;
    if (escapedValue === '') { return []; }

    const regex = new RegExp('^' + escapedValue, 'i');
    let suggestionsArray = _.difference(this.props.allValues, this.props.visibleValues);

    return suggestionsArray.filter((filter) => (
      filter.name ? regex.test(filter.name) : filter.extension
    ));
  }

  getSuggestionValue(suggestion) {
    return suggestion.name ? suggestion.name : suggestion.extension;
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, { suggestion }) => {
    event.preventDefault();
    this.setState({ value: '' });
    this.props.onSelect(suggestion);
  }

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  renderSuggestion(suggestion) {
    return (
      <span className="suggestion-item">
        <span className="suggestion-name">
          {suggestion.name ? suggestion.name : suggestion.extension}
        </span>
        <span className="suggestion-count">{suggestion.count}</span>
      </span>
    );
  }

  render() {
    let { value, suggestions} = this.state;
    const { id } = this.props;
    const inputProps = {
      value,
      onChange: this.onChange
    };

    return (
      <div className="filter-search-row">
        <span>Other:</span>
        <span className="bff-search" />
        <Autosuggest
          id={id}
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
        />
      </div>
    );
  }
}

AutosuggestSearch.propTypes = {
  id: PropTypes.string,
  allValues: PropTypes.array.isRequired,
  visibleValues: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default AutosuggestSearch;
